import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { formatDate, formatShortDate } from '../../utils/conditions';
interface InlineDateFieldProps {
  value?: string;
  onSave: (value: string | undefined) => void;
  ariaLabel: string;
  emptyLabel: string;
  tone?: 'default' | 'success' | 'danger';
}
const toneClass = {
  default: 'text-slate-700',
  success: 'text-steel',
  danger: 'font-medium text-red-600'
};
export function InlineDateField({
  value,
  onSave,
  ariaLabel,
  emptyLabel,
  tone = 'default'
}: InlineDateFieldProps) {
  const [editing, setEditing] = useState(false);
  if (editing) {
    return <input type="date" autoFocus defaultValue={value} aria-label={ariaLabel} onBlur={e => {
      onSave(e.target.value || undefined);
      setEditing(false);
    }} onKeyDown={e => {
      if (e.key === 'Enter') e.currentTarget.blur();
      if (e.key === 'Escape') setEditing(false);
    }} className="w-full rounded-md border border-brand px-1.5 py-1 text-xs text-slate-800 focus:outline-none focus:ring-1 focus:ring-brand" data-id="element-174" data-mp="hv8awof2nw8w" />;
  }
  if (!value) {
    return <button type="button" onClick={() => setEditing(true)} aria-label={`${ariaLabel}: not set`} className="-mx-1 inline-flex items-center gap-1 whitespace-nowrap rounded px-1 py-0.5 text-sm text-slate-400 transition-colors hover:bg-slate-100 hover:text-brand focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-175" data-mp="3ucszp6y6jhe">
        <PlusIcon className="h-3 w-3" aria-hidden="true" data-id="element-176" data-mp="illpmi99p541" />
        {emptyLabel}
      </button>;
  }
  return <button type="button" onClick={() => setEditing(true)} aria-label={`${ariaLabel}: ${formatDate(value)}. Edit`} title={formatDate(value)} className={`-mx-1 inline-flex items-center whitespace-nowrap rounded px-1 py-0.5 text-sm tabular-nums hover:bg-slate-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand ${toneClass[tone]}`} data-id="element-177" data-mp="rkgsplh0lz34">
      {formatShortDate(value)}
    </button>;
}